import styled from 'styled-components';

export const SummaryWrapper = styled.div`
    margin: 0 0 10px 0;
    h3 {
        background: ${props => props.theme.colors.background.summary};
        font-size: 0.8rem;
        margin: 0 0 5px 0;
        padding: 5px 10px;
        color: ${props => props.theme.colors.text.summary};
        font-weight: bold;
    }
`;

export const SummarySection = styled.div`
    display: flex;

    table {
        table-layout: fixed;
        width: 100%;
        border-collapse: collapse;
        background: #fff;

        thead {
            font-size: 0.8rem;
            font-weight: 500;
            text-align: center;
            background-color: ${props => props.theme.colors.background.summaryHeader};
            border-bottom: 2px solid ${props => props.theme.colors.border.summaryHeader};
            color: ${props => props.theme.colors.text.summary};
            margin: 0 0 0.5rem;
        }

        th,
        td {
            padding: 0.15rem 0.5rem;
            font-size: 0.7rem;
            text-align: left;
            white-space: pre-wrap;
            overflow: hidden;
            text-overflow: ellipsis;
            vertical-align: top;
        }

        th {
            font-size: 0.8rem;
            font-weight: 600;
        }

        td {
            font-size: 0.75rem;
        }

        .right {
            text-align: right;
        }

        .bold-col {
            font-weight: 500;
        }

        .total {
            font-style: italic;
        }
    }
`;
export const SummarySectionSectionInputElementWrapper = styled.div`
    margin: 0 0 10px 0;
    padding: 5px;
`;

export const SectionHeader = styled.div`
    font-weight: 400;
    font-size: 0.9rem;
    padding: 2px;
    margin: 5px 0;
`;

export const SummaryItem = styled.div`
    label {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 10px;
        font-weight: 500;
    }
    h5 {
        width: 3rem;
    }
`;
